// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  name: 'ginya-prod',
  version: 'Error: no tags found (local or remote).',
  production: false,
  bucketName: 'ginya',
  databaseUrl: { supabase: 'https://wbczrwlfwyzwyudyaxur.supabase.co', middleware: '' },
  posCloud: {
    apiURL: 'https://ginya.menucat.de/api',
  },
  editEnabled: 'true',
  defaultLanguage: 'de',
  databaseAnonKey: { supabase: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndiY3pyd2xmd3l6d3l1ZHlheHVyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Nzc4ODUyNDQsImV4cCI6MjA5MzQ2MTI0NH0.j3T7Svgysdph0Y2ob_r6EjpFk4EIHQ4IGI4I7f0vQuw', middleware: '' },
  sentryDSN: '',
  posthogKey: 'phc_m3dOImc0jDJ5IzfKERikqSr4Nshq8XFVWV6DJKgYzhu',
  posthogHost: 'https://eu.i.posthog.com',
  posthogProxyHost: 'https://t.unauorder.com',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
